<template>
    <div>
        <smallbutton @click="UpdatePersonRole()" :toplabel="updateText" :class="buttonclass"/>
        <!-- ACCT NOTE MODAL -->
          <actionmodal ref="mymodal"> 
            <template v-slot:body>
                <form ref="myform">
                    <label class="titlelabel">{{updateText}}</label>
                    
                    <formentry inputid="rolename" :isFirstField="trueParam" inputtype="text"  label="Name" :isrequired="isRequired('Name')"  v-model="PersonRole.name" v-if="isVisible('Name')"/>
                    <div class="entry"  v-if="isVisible('IsActive')">
                        <div class="entryTextDiv">
                            <label class="entryLabel" for="isactivecheck">Is Active</label>
                        </div>
                        <div class="entryTextDiv">
                            <input id="isactivecheck" class="entryCheckbox" type="checkbox" v-model="PersonRole.isActive" >
                        </div>
                    </div>
                   
    
                    <smallbutton  @click="saveNewPersonRole()" toplabel="Save" v-if="!needConfirm"/>
                    <smallbutton  @click="saveNewPersonRole(true)" toplabel="Confirm Save" v-if="needConfirm"/>
                    <smallbutton  @click="cancelupdate()" toplabel="Cancel"/>
                    <div>
                        <label class="responsemessage">{{message}}</label>
                   </div>

                   <!-- <confirm ref="overrideDuplicate" :showButton="paramFalse" :body="confirmPersonRoleMessage" title="Add PersonRole" @yes="saveNewPersonRole(true)"   /> -->
              </form>

            </template>
          </actionmodal>
        </div>
    </template>
    
    <script>
    import {mapFields} from 'vuex-map-fields'
    import datamethods from '../../services/datamethods.js'
    import format from '../../format.js'
    import smallbutton from '../controls/button.vue'
    import actionmodal from '../controls/actionmodal.vue'
    import formentry from '../controls/entry.vue'
    import linkbutton from '../controls/linkbutton.vue'
    import pencilbutton from '../controls/pencilbutton.vue'

    export default {
        name:'updatePersonRole',
        components:{
            smallbutton,
            actionmodal,
            formentry,
            linkbutton,
            pencilbutton,
            
        },
        props:{
            inPersonRole:{
                type:Object,
            },
       
            isAdd:{
                type:Boolean,
                default:false
            },
            buttonclass:{
                type:String,
                default:'updatebutton'
            },
            isStudent:{
                type:Boolean,
                default:false
            },
            isEmployee:{
                type:Boolean,
                default:true
            },
    
        },
        mixins:[datamethods,format],
        data(){
            return{
                message:'',
                PersonRole:{
                    id:0,
                    name:null,
                    isActive:true,
                    isEmployee:this.isEmployee,
                    isStudent:this.isStudent
                    
                },
                confirmPersonRoleMessage:null,
                trueParam:true
            }
            
        },
        computed:{
            ...mapFields([
               'locationList',
            ]),
           
            updateText(){
                if(this.isAdd){
                    return "Add Role" 
                }else{
                    return "Update Role" 
                }
                
            },
       
        },
        methods:{
      
            isRequired(field){
                
                switch (field) {
                    case "Name":
                        return true
                        break;
                    

                    default:
                        return false
                        break;
                }
            },
            isVisible(field){
                
               // console.log('isvis ' + field)
                switch (field) {
         
                    default:
                        return true
                        break;
                }
            },
       
           UpdatePersonRole(){
            this.needConfirm=false
            this.message=null
            if(this.isAdd){
                this.PersonRole = {
                    id:0,
                    name:null,
                    isActive:true,
                    isEmployee:this.isEmployee,
                    isStudent:this.isStudent
                    
              
                }
                
            }else{
                this.PersonRole = this.inPersonRole
       
            }
            

            this.$refs.mymodal.openModal()
            this.$nextTick(()=>{
                this.$refs.rolename.Focus()
            })
           },
            
            checkClass(selected){
                if(selected){
                    return "entryCheckLabelbold"
                }else{
                    return "entryCheckLabel"
                }
            },
            cancelupdate(){
                this.$refs.mymodal.closeModal()
                this.$emit('refresh')
                
            },
            async saveNewPersonRole(overridedup=false){
                this.message=null
                if(this.$refs.myform.checkValidity()==false){
                    this.message = "Please fill in all required fields"
                    return}
                
                
                this.PersonRole.locationId=-1
                
                let req = {
                    PersonRole:this.PersonRole,
      
                }
                this.$store.dispatch('beforeAPI');
                var response = await this.callAPI(req,'updatepersonrole')
                if(response.Successful){
                    this.needConfirm=false
                    this.$refs.mymodal.closeModal()
                    //console.log(response)
    
                    if(this.isAdd){
                        this.$emit('refreshnew',response.ResponseInteger)
                    }else{
                        this.$emit('refresh')
                    }
                    
                }else{
                    if(response.Message.includes('Do you want to add anyway?')){
                        this.message = response.message
                        this.needConfirm=true
                    }
                    this.message = response.Message
                }
                this.pleaseWait=false;
            },
            
             
           
            
           
        }
    }
    </script>
    
    <style>
    .entrySelectPersonRole{
    margin:5px 5px 5px 5px;
    width:100%;
    height:25px;
    font-size:inherit;
}
    .entryCheckLabel{
        margin:0px 0px 0px 5px;
        font-size:medium;
        text-align: left;  
        max-width: 420px;
    }
    .entryCheckLabelbold{
        margin:0px 0px 0px 5px;
        font-size:medium;
        text-align: left;  
        max-width: 420px;
        font-weight:bold;
    }
    .updatebutton{
        height:30px;
        width:150px;
        border-radius: 5px;
        padding:3px;
        margin:0px 0px 10px 0px;
    }
    .locationcheck{
    height:15px;
    margin-top:15px;
    margin-right:5px;
}
.locationdiv{
    text-align: left;
    display:grid;
    grid-template-columns: 1fr 15fr;
}
.locationCheckbox{
    height:15px;
    margin-top:15px;
}
    </style>
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    